var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.kind,_vm._b({tag:"Component",staticClass:"ds-bo-icon",attrs:{"alt":_vm.altMessage,"aria-hidden":_vm.ariaHidden,"kind":_vm.kind},on:{"v-on":_vm.$listeners}},'Component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }